import React from 'react';
import { useRouter } from 'next/router';

import { Fade } from 'components/animations';
import { Loader } from 'components/ui';
import { APP_ROUTES } from 'constants/routes';

import type { SetTimeoutReturnType } from 'types';

import styles from './NavigationLoader.module.scss';

const LOADER_THRESHOLD = 100;

const NavigationLoader = () => {
  const [isLoading, setLoading] = React.useState(false);
  const router = useRouter();
  const timer = React.useRef<SetTimeoutReturnType[]>([]);

  React.useEffect(() => {

    const start = () => {
      if (!window.location.pathname.startsWith(APP_ROUTES.LOGIN)) {
        timer.current.push(setTimeout(() => setLoading(true), LOADER_THRESHOLD));
      }
    };

    const end = () => {
      if (timer.current.length) {
        timer.current.forEach((timeoutId) => clearTimeout(timeoutId));
        timer.current = [];
      }
      setLoading(false);
    };

    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', end);
    router.events.on('routeChangeError', end);

    return () => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', end);
      router.events.off('routeChangeError', end);
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fade
      className={styles.root}
      isVisible={isLoading}
      persist={false}
      enterDuration={400}
      exitDuration={200}
    >
      <Loader
        spinnerClassName={styles.spinner}
        fullscreen
        transparent
        size={24}
        lineWeight={2}
      />
    </Fade>
  );
};

export default NavigationLoader;
